import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Query } from "react-apollo";

import { ChallengeQuery, challengeQuery } from "../graphql/challenge";
import ChallengeCard from "../challenge/ChallengeCard";

const ChallengePage = ({ match }: RouteComponentProps<{ id: string }>) => (
  <Query<ChallengeQuery>
    query={challengeQuery}
    variables={{ id: match.params.id }}
  >
    {({ data: { challenge, me = {} } = {}, loading, error, refetch }) => {
      if (loading) return <div>Loading...</div>;
      if (error) {
        return (
          <div>
            <strong>Error:</strong> {error.message}
          </div>
        );
      } else if (!challenge) {
        return <div>Not found</div>;
      } else if (challenge.game) {
        return <div>Should redirect to {challenge.game.id}</div>;
      } else {
        return (
          <div>
            <h1>Challenge</h1>
            <ChallengeCard fluid challenge={challenge} />
          </div>
        );
      }
    }}
  </Query>
);

export default ChallengePage;
